// Shared helpers for ranking rows coming from the ranking endpoints

export function getTeamId(item = {}) {
    return item.id || item.teamId || (item.team ? item.team.id : null)
}

// Adds `position` (1-based if missing) and `previousPosition` (from `previousStanding`) to every row
export function prepareRanking(rawRanking = []) {
    const ranking = (Array.isArray(rawRanking) ? rawRanking : []).map((item, index) => {
        const normalizedPosition = Number(item?.position)
        return {
            ...item,
            position: Number.isFinite(normalizedPosition) ? normalizedPosition : (index + 1),
            previousPosition: null
        }
    })

    const sortedByPreviousStanding = [...ranking].sort((a, b) => {
        const previousA = Number(a?.previousStanding) || 0
        const previousB = Number(b?.previousStanding) || 0
        return previousB - previousA
    })

    sortedByPreviousStanding.forEach((item, index) => {
        item.previousPosition = index + 1
    })

    return ranking
}

// Last five results as 'W' / 'L', oldest first
export function getLastFiveForm(item = {}) {
    const raw = item?.form || item?.last_5 || item?.last5 || item?.recentForm || item?.lastFive || ''

    if (Array.isArray(raw)) {
        return raw
            .map(value => String(value).trim().toUpperCase())
            .filter(value => value === 'W' || value === 'L')
            .slice(-5)
    }

    const source = String(raw).toUpperCase()
    const compact = source.match(/[WL]/g)
    if (compact && compact.length) {
        return compact.slice(-5)
    }

    const words = source.match(/WIN|LOSS/g)
    if (words && words.length) {
        return words.map(value => (value === 'WIN' ? 'W' : 'L')).slice(-5)
    }

    return []
}
